export function Logout() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Settings-Icon/Logout">
        <g id="Icon">
          <path
            d="M14.6665 10.9578C14.6665 11.7112 14.6665 12.0879 14.5143 12.2725C14.3821 12.433 14.1826 12.5226 13.9749 12.5148C13.7357 12.5058 13.4542 12.2556 12.8911 11.7551L9.56335 8.79705C9.25315 8.52132 9.09806 8.38346 9.0409 8.22067C8.99071 8.07771 8.99071 7.92192 9.0409 7.77896C9.09806 7.61617 9.25315 7.4783 9.56335 7.20258L12.8911 4.24454C13.4542 3.74404 13.7357 3.49379 13.9749 3.48484C14.1826 3.47707 14.3821 3.56665 14.5143 3.72708C14.6665 3.91175 14.6665 4.28843 14.6665 5.04178V10.9578Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.33312 10.9578C7.33312 11.7112 7.33312 12.0879 7.18095 12.2725C7.04874 12.433 6.84926 12.5226 6.64152 12.5148C6.4024 12.5058 6.12086 12.2556 5.5578 11.7551L2.23001 8.79705C1.91982 8.52132 1.76472 8.38346 1.70757 8.22067C1.65737 8.07771 1.65737 7.92192 1.70757 7.77896C1.76472 7.61617 1.91982 7.4783 2.23001 7.20258L5.5578 4.24454C6.12086 3.74404 6.4024 3.49379 6.64152 3.48484C6.84926 3.47707 7.04874 3.56665 7.18095 3.72708C7.33312 3.91175 7.33312 4.28843 7.33312 5.04178V10.9578Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
}
